import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import logo from '../img/logo.svg';
import { AuthContext } from '../contexts/AuthContext';
import { useTelemetryContext } from "../contexts/TelemetryContext";

export default function Login() {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [remember, setRemember] = useState(false);
	const [error, setError] = useState(null);
	const navigate = useNavigate();
	const { login } = useContext(AuthContext);
	const { selectedProduct } = useTelemetryContext();
	const [loginSuccessful, setLoginSuccessful] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError(null);

		try {
			// Laravel boolean validation accepts 1/0 (not the string "true"/"false")
			const body = new URLSearchParams({
				email,
				password,
				remember: remember ? '1' : '0',
			});

			const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/login`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Accept': 'application/json'
				},
				body,
			});

			if (!response.ok) {
				setError('Invalid email or password');
			} else {
				const data = await response.json();
				login(data.access_token, remember);
				setLoginSuccessful(true);
			}
		} catch (err) {
			setError(err.message);
		}
	};

	useEffect(() => {
		if (loginSuccessful && selectedProduct) {
			navigate(`/stores/${selectedProduct.store_id}/plugins/${selectedProduct.id}/dashboard`);
		}
	}, [loginSuccessful, selectedProduct, navigate]);

	return (
		<div className="wpb-telemetry-loginpage">
			<header>
				<img src={logo} alt="Telemetry"/>
			</header>
			<div className="wpb-telemetry-form-wrapper">
				<form onSubmit={handleSubmit} className="telemetry-loginform" id="telemetry-loginform"
					name="telemetry_loginform">
					<h1>Sign in</h1>
					<div className="wpb-telemetry-form">
						<div className="wpb-telemetry-field wpb-name-field">
							<input
								id="email"
								name="email"
								type="email"
								autoComplete="username"
								placeholder="Email address *"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
							/>
							<div className="validation-msg" id="email-error">This field is required!</div>
							<div className="validation-msg" id="email-format-error">Invalid email format!</div>
						</div>
						<div className="wpb-telemetry-field wpb-password-field">
							<input
								id="password"
								name="password"
								type="password"
								autoComplete="current-password"
								placeholder="Password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								required
							/>
							<div className="validation-msg" id="password-error">This field is required!</div>
						</div>
						{error && <div className="error" style={{float: 'right'}}>{error}</div>}
						<div className="wpb-telemetry-remember">
							<label htmlFor="remember_me" className="wpb-telemetry-remember-label">
								<input
									id="remember_me"
									name="remember"
									type="checkbox"
									checked={remember}
									onChange={(e) => setRemember(e.target.checked)}
								/>
								<span>Remember Me</span>
							</label>
						</div>
						<button type="button" className="forget-pass">Forgot your password?</button>
						<button type="submit">Sign in to your dashboard</button>
					</div>
				</form>
			</div>
		</div>
	);
}
